<script lang="ts">
  import { CommonTexts } from '../services/CommonTexts';
</script>

<footer class="LayoutFooter">
  <ul class="asBlock" role="presentation">
    <li>{CommonTexts.Confidential}</li>
    <li>{CommonTexts.Copyright}</li>
  </ul>
</footer>

<style lang="scss">
  @use '../../styles/mixins';
  @use '../../styles/defintions';

  .LayoutFooter {
    @include mixins.theme-svelte-tag(font-color, var(--color-gray-800), var(--color-gray-50));
    @include mixins.theme-svelte-tag(background-color, var(--color-gray-100), var(--color-gray-900));
    @include mixins.theme-svelte-tag(border-color, var(--color-gray-300), var(--color-gray-700));

    position: relative;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    background: var(--layout-background-color);
    color: var(--layout-font-color);
    border-top: 1px solid var(--layout-border-color);
    z-index: 500;
    @include mixins.greaterSmall() {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
    }

    ul {
      font-size: calc(var(--font-size) * 0.75);
      display: grid;
      grid-template-columns: repeat(2, auto);
      justify-content: space-between;
      max-width: #{defintions.$wrapperWidth};
      margin: 0 auto;

      &,
      > li {
        line-height: 1;
      }

      > li {
        padding: 0.5rem;

        + li {
          text-align: right;
        }
      }
    }
  }
</style>
